import { forwardRef } from 'react';
import { useMatch } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import { RouterTabs } from '@components/header/router-tabs';

import { useApplicationTabs } from 'hooks/useApplicationTabs';
import { useStore } from 'models/Provider';

export const ApplicationTabs = observer(
  forwardRef(({ application, hasBorder = false }, ref) => {
    const { t } = useStore();
    const section = useMatch('/jobs/:jobID/application/:applicationID/:section')?.params.section;
    const tabs = useApplicationTabs(application);

    return (
      <div ref={ref}>
        <RouterTabs
          ariaLabel={t('application.tabs.label')}
          hasBorder={hasBorder}
          shouldCollapseOnMobile
          activeSection={section}
          tabs={tabs.map((tab) => ({
            label: tab.display,
            to: tab.link,
            section: tab.value,
            icon: tab.icon,
            counter: tab.count || undefined,
            counterVariant: tab.activeCount ? 'green' : undefined,
            isCounterSolid: Boolean(tab.activeCount),
            hasError: Boolean(tab.error),
            dataCy: `application-tabs:${tab.value}`,
          }))}
        />
      </div>
    );
  }),
);
